
import 'bootstrap/dist/css/bootstrap.min.css';
import Plot from 'react-plotly.js';
import React from 'react';
//import ModalView from './ModalView';

class Options extends React.Component
{
  constructor(props)
  {
    super(props);

    const countries = [ "Afghanistan","Albania","Algeria","Angola","Argentina","Australia","Austria","Azerbaijan","Bangladesh","Belgium","Belize","Benin","Bolivia (Plurinational State of)","Bosnia and Herzegovina","Botswana","Brazil","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Central African Republic","Chad","Chile","China","Colombia","Congo (the Democratic Republic of the)","Congo (the)","Costa Rica","Côte d’Ivoire","Croatia","Cuba","Czech Republic (the)","Djibouti","Dominican Republic (the)","Ecuador","Egypt","El Salvador","Ethiopia","Fiji","France","Gambia (the)","Georgia","Germany","Germany Fed Rep","Ghana","Greece","Guatemala","Guinea","Guyana","Haiti","Honduras","Hong Kong","Hungary","India","Indonesia","Iran (Islamic Republic of)","Iraq","Ireland","Israel","Italy","Jamaica","Japan","Jordan","Kazakhstan","Kenya","Korea (the Democratic People's Republic of)","Korea (the Republic of)","Lao People's Democratic Republic (the)","Liberia","Macedonia (the former Yugoslav Republic of)","Madagascar","Malawi","Malaysia","Mali","Mauritania","Mexico","Moldova (the Republic of)","Mongolia","Morocco","Mozambique","Myanmar","Namibia","Nepal","Netherlands (the)","New Zealand","Nicaragua","Niger (the)","Nigeria","Pakistan","Panama","Papua New Guinea","Paraguay","Peru","Philippines (the)","Poland","Portugal","Puerto Rico","Romania","Russian Federation (the)","Rwanda","Saint Vincent and the Grenadines","Saudi Arabia","Senegal","Serbia","Serbia Montenegro","Sierra Leone","Slovakia","Solomon Islands","Somalia","South Africa","South Sudan","Soviet Union","Spain","Sri Lanka","Sudan (the)","Switzerland","Syrian Arab Republic","Taiwan (Province of China)","Tajikistan","Tanzania, United Republic of","Thailand","Togo","Tunisia","Turkey","Uganda","Ukraine","United Kingdom of Great Britain and Northern Ireland (the)","United States of America (the)","Uruguay","Venezuela (Bolivarian Republic of)","Viet Nam","Yemen","Yugoslavia","Zambia","Zimbabwe","Anguilla","Antigua and Barbuda","Bahamas (the)","Barbados","Bermuda","Comoros (the)","Cook Islands (the)","Denmark","Dominica","Grenada","Guadeloupe","Guam","Lebanon","Lesotho","Martinique","Mauritius","Micronesia (Federated States of)","New Caledonia","Niue","Norway","Oman","Réunion","Saint Kitts and Nevis","Saint Lucia","Samoa","Sweden","Tokelau","Tonga","Trinidad and Tobago","Turks and Caicos Islands (the)","Tuvalu","Vanuatu","Virgin Island (U.S.)","Africa","Åland","American Samoa","Andorra","Antarctica","Antigua And Barbuda","Armenia","Aruba","Asia","Bahamas","Bahrain","Baker Island","Belarus","Bhutan","Bolivia","Bonaire, Saint Eustatius And Saba","Bosnia And Herzegovina","British Virgin Islands","Burma","Cape Verde","Cayman Islands","Christmas Island","Comoros","Congo","Congo (Democratic Republic Of The)","Côte D'Ivoire","Curaçao","Cyprus","Czech Republic","Denmark (Europe)","Dominican Republic","Equatorial Guinea","Eritrea","Estonia","Europe","Falkland Islands (Islas Malvinas)","Faroe Islands","Federated States Of Micronesia","Finland","France (Europe)","French Guiana","French Polynesia","French Southern And Antarctic Lands","Gabon","Gambia","Gaza Strip","Greenland","Guernsey","Guinea Bissau","Heard Island And Mcdonald Islands","Iceland","Iran","Isle Of Man","Jersey","Kingman Reef","Kiribati","Kuwait","Kyrgyzstan","Laos","Latvia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Malta","Mayotte","Moldova","Monaco","Montenegro","Montserrat","Netherlands","Netherlands (Europe)","Niger","North America","North Korea","Northern Mariana Islands","Oceania","Palau","Palestina","Palmyra Atoll","Philippines","Qatar","Reunion","Russia","Saint Barthélemy","Saint Kitts And Nevis","Saint Martin","Saint Pierre And Miquelon","Saint Vincent And The Grenadines","San Marino","Sao Tome And Principe","Seychelles","Singapore","Sint Maarten","Slovenia","South America","South Georgia And The South Sandwich Isla","South Korea","Sudan","Suriname","Svalbard And Jan Mayen","Swaziland","Syria","Taiwan","Tanzania","Timor Leste","Trinidad And Tobago","Turkmenistan","Turks And Caicas Islands","United Arab Emirates","United Kingdom","United Kingdom (Europe)","United States","Uzbekistan","Venezuela","Vietnam","Virgin Islands","Western Sahara","Asia (excl. China & India)","Bonaire Sint Eustatius and Saba","Brunei","Cook Islands","Cote d'Ivoire","Curacao","Czechia","Democratic Republic of Congo","Eswatini","EU-27","EU-28","Europe (excl. EU-27)","Europe (excl. EU-28)","Faeroe Islands","Guinea-Bissau","Macao","Maldives","Marshall Islands","Nauru","North America (excl. USA)","North Macedonia","Palestine","Saint Helena","Saint Pierre and Miquelon","Sao Tome and Principe","Sint Maarten (Dutch part)","Timor","Turks and Caicos Islands","World" ];
    
    const problems = ["Annual CO2 per capita","Flood","Storm","Temperature"];

    this.state = {
      valueCountry: "Afghanistan",
      valueCategory: "Annual CO2 per capita",
      items_countries: countries.map((country) =>
        <option >
          {country}
        </option>
      ),
      items_categories: problems.map((problem) =>
        <option >
          {problem}
        </option>
      ),
      data_plot: {},
      layout: {},
      message: '',
      show:false,
      forecast_text:''

    };

    this.handleClickSelectCountry = this.handleClickSelectCountry.bind(this);
    this.handleChangeSelectCountry = this.handleChangeSelectCountry.bind(this);
    this.handleClickSelectCategory = this.handleClickSelectCategory.bind(this);
    this.handleChangeSelectCategory = this.handleChangeSelectCategory.bind(this);
    this.handleClick = this.handleClick.bind(this);
  

  }

  
  componentDidMount() {
    this.handleClick();
  }
  

  handleClick()
  {




    fetch(this.props.baseUrl + 'climate/' + this.state.valueCountry + '&' + this.state.valueCategory).then(function (data)
    {
      return data.json();
    }).then(json =>
    {
      if (json === null)
      {
        this.setState({
          show:false,
          message: "No data for :",
          data_plot: [],
          layout: {}
        });
      } else
      {
        const Lo_95 =json.Lo_95.split(',');
        const Hi_95 =json.Hi_95.split(',');
        const Years_forecast =json.Years_forecast.split(',');
        const Point_forecast =json.Point_forecast.split(',');

        this.setState({
          show:true,
          message:'Ets forecast for:',
          forecast_text: Years_forecast.map((year) =>
             <p className='text-center'>
               In {year} year, point forecast is {Point_forecast[parseInt(year)%2022]}
               <br></br>with 95% confidence interval [{Lo_95[parseInt(year)%2022]},{Hi_95[parseInt(year)%2022]}]</p>
        ),
          data_plot: [
            {
              x: json.Year.split(','),
              y: json.Value.split(','),
              type: 'scatter',
              mode: 'lines+markers',
              name: json.Tipo,
              marker: { color: 'red' },
            },
            {
              x: Years_forecast,
              y: Point_forecast,
              type: 'scatter',
              mode: 'lines+markers',
              name: 'Forecast',
              marker: { color: 'blue' },
            },
          ],
          layout: { width: 550, height: 600, title: json.Country + ' ' + json.Tipo },

        });
      }
    });




  }



  handleClickSelectCountry(event)
  {
    
    this.handleClick();

  }


  handleChangeSelectCountry(event)
  {
    this.setState({
      valueCountry: event.target.value
    });

    

  }

  handleClickSelectCategory(event)
  {
    this.handleClick();
  }

  handleChangeSelectCategory(event)
  {
    this.setState({
      valueCategory: event.target.value
    });


  }




  render()
  {



    return (
      <div class="row">
        <div className="col-md-12">
          <div className="card" >
            <div className="card-body">
              <h5 className="card-title">Options:</h5>
              <div className="input-group mb-3">

                <span className="input-group-text">Country:</span>
                <select value={this.state.valueCountry}
                  onClick={this.handleClickSelectCountry}
                  onChange={this.handleChangeSelectCountry}
                  className="form-select"
                >
                  {this.state.items_countries}
                </select>

                <span className="input-group-text">Category:</span>
                <select value={this.state.valueCategory}
                  onClick={this.handleClickSelectCategory}
                  onChange={this.handleChangeSelectCategory}
                  className="form-select"
                >
                  {this.state.items_categories}
                </select>

              </div>





            </div>
          </div>
          <div class="row">
            <div className="col-md-6">
              <Plot
                data={this.state.data_plot}
                layout={this.state.layout}
              />
            </div>
            <div className="col-md-6">
            <h5 class='text-center text-info'>
                  {this.state.message } <br></br>
                  {this.state.valueCountry} {this.state.valueCategory} </h5>
                  
           {this.state.show && this.state.forecast_text}
           
            </div>
          </div>
        </div>



      </div>

    );
  }
}

export default Options;
